import { jsx as _jsx } from "react/jsx-runtime";
import { I18nProvider } from 'react-aria-components';
/** The one display language of Kanos (AGENTS.md: German only). */
export const DISPLAY_LOCALE = 'de-DE';
/**
 * Fixes numbers, dates and the texts React Aria writes itself to German, whatever language the
 * browser asks for - without it a field formats `1.000` as `1,000` on an English system.
 */
export function DisplayLocale({ children }) {
    return _jsx(I18nProvider, { locale: DISPLAY_LOCALE, children: children });
}
//# sourceMappingURL=locale.js.map